
import { Navigate } from 'react-router-dom';
import { gettoken, getidusuario } from 'functions/gettabconfig';


function PrivateRoute(props) {
    const logado = gettoken();
    const idUsuario = getidusuario();
    // Considera visitante se id_usuario for 0 ou '-1'
    const isVisitante = idUsuario === 0 || idUsuario === '0' || idUsuario === '-1' || !idUsuario;
    if (!logado || isVisitante) {
        return <Navigate to='/login' />;
    }
    return props.children;
}

export default PrivateRoute;